<template>
	<div class="add-car">
		<header-bar :headerData="headerData"></header-bar>
		<router-link to="/mapply/violationindex">
			<div class="add-car-box">
				<div class="add-car-content">
					<div class="add-car-icon"></div>
					<div class="title">添加爱车</div>
					<div class="info"><span>您还未添加车辆信息哦！</span></div>
				</div>
			</div>
		</router-link>
	</div>
</template>

<script>
	import HeaderBar from '@/components/violation/header';
	export default {
		name: 'addcar',
		data() {
			return {
				headerData: {
					headerTxt: '添加车辆',
					isButtonShow: false
				},
			}
		},
		beforeCreate: function() {
			getCommonJsIns.initSingleCSSNEW({
				cssURL: "/css/mapply/violation/index.css"
			});
		},
		mounted: function() {
			var self = this;
			//确保重要依赖的js加载完成
			getCommonJsIns.initJSNEW(this.webReady);
		},
		components: {
			HeaderBar
		},
		methods: {
			webReady: function() {

			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/views/violation/addCar.vue